import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {VirtualMetricOPEEnum} from "./VirtualMetricOPEEnum";


class I {
  id!: number;
}

class O {

}

export class DelVirtualMetricCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(VirtualMetricOPEEnum.DelVirtualMetric);
    this.i = new I();
    this.o = new O();
  }
}
